import { Box, Button, DialogActions, DialogContent, Grid, Paper ,TextField} from '@material-ui/core';
// import { useStore } from '@tanstack/react-form'; // KALDIRILDI
import React from 'react';
import { Cost } from '../components/Cost';
import { useDialog } from 'src/contexts/DialogContext';
import moment from 'moment';

function useFormValues(form, selector) {
  const [val, setVal] = React.useState(() => selector(form.values));
  React.useEffect(() => {
    const unsub = form.subscribe(() => setVal(selector(form.values)));
    return unsub;
  }, [form, selector]);
  return val;
}

export function Actions({ form, user }) {
    const currency = user.CurrencyUnit;
    const tanentCode = user.TenantCode;
    const {
      RepairCompletedDate,
      WorkOrderLabours,
      WorkOrderMaterials,
      WorkOrderTransport,
      WorkOrderExtra,
      Notes
    } = useFormValues(form, v => ({
      RepairCompletedDate: v.RepairCompletedDate,
      WorkOrderLabours: v.WorkOrderLabours || [],
      WorkOrderMaterials: v.WorkOrderMaterials || [],
      WorkOrderTransport: v.WorkOrderTransport || [],
      WorkOrderExtra: v.WorkOrderExtra || [],
      Notes: v.Notes || '',
    }));
    const { openDialog, closeDialog } = useDialog();

    return (
        <Paper>
            <Box px={2} py={1} mb={1}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                            <TextField
                                label={"Final Notes"}
                                name="Notes"
                                multiline
                                rows={4}
                                fullWidth
                                value={Notes}
                                onChange={(e) => form.setFieldValue('Notes', e.target.value)}
                                variant="outlined"
                            />
                        </Grid>
                    <Grid item xs={12}>
                        <Button
                            fullWidth
                            color="primary"
                            variant="contained"
                            disabled={!!RepairCompletedDate}
                            onClick={() =>
                                openDialog(() => (
                                    <>
                                        <DialogContent>
                                            You are stating that the repair process has been completed.
                                        </DialogContent>
                                        <DialogContent>Can you confirm this?</DialogContent>
                                        <DialogActions>
                                            <Button
                                                onClick={() => {
                                                    form.setFieldValue('RepairCompletedDate', moment.utc().format());
                                                    closeDialog();
                                                }}
                                                color="primary"
                                                variant="contained"
                                            >
                                                Yes
                                            </Button>
                                            <Button onClick={closeDialog} color="secondary">
                                                No
                                            </Button>
                                        </DialogActions>
                                    </>
                                ))
                            }
                        >
                            Repair completed
                        </Button>
                    </Grid>

                    <Grid item px={2} pb={2}>
                        <Cost
                            currency={currency}
                            tenantCode={tanentCode}
                            workOrderLabours={WorkOrderLabours}
                            workOrderMaterials={WorkOrderMaterials}
                            workOrderTransport={WorkOrderTransport}
                            workOrderExtra={WorkOrderExtra}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
